import React, { useEffect, useState } from 'react';
import { FaLink } from 'react-icons/fa';
import iam2 from '../assets/iam2.png';
import mouseGif from '../assets/mouse.gif';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const phrases = ['clean UIs. ', 'user-friendly apps. ', 'responsive layouts. '];

const spring = {
  type: 'spring',
  stiffness: 300,
};

const Home = () => {
  const [text, setText] = useState('');
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  const controlsText = useAnimation();
  const controlsImg = useAnimation();

  const [refText, inViewText] = useInView({ triggerOnce: true });
  const [refImg, inViewImg] = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inViewText) controlsText.start({ x: 0, opacity: 1 });
    else controlsText.start({ x: -200, opacity: 0 });

    if (inViewImg) controlsImg.start({ x: 0, opacity: 1 });
    else controlsImg.start({ x: 200, opacity: 0 });
  }, [inViewText, inViewImg, controlsText, controlsImg]);

  useEffect(() => {
    if (index >= phrases.length) return;

    if (!deleting && subIndex === phrases[index].length) {
      setTimeout(() => setDeleting(true), 1500);
      return;
    }

    if (deleting && subIndex === 0) {
      setDeleting(false);
      setIndex((prev) => (prev + 1) % phrases.length);
      return;
    }

    const timeout = setTimeout(() => {
      setSubIndex((prev) => (deleting ? prev - 1 : prev + 1));
      setText(phrases[index].substring(0, subIndex));
    }, deleting ? 50 : 100);

    return () => clearTimeout(timeout);
  }, [subIndex, index, deleting]);

  return (
    <section
      id="home"
      className="min-h-screen flex flex-col bg-[#F5F3EF] text-[#4B4033] pt-20 pb-15"
    >
      <div className="w-full max-w-screen-xl mx-auto flex flex-col items-center justify-center flex-grow px-6 py-10">
        <div className="flex flex-col-reverse lg:flex-row items-center justify-center w-full max-w-6xl mx-auto gap-10">
          <motion.div
            ref={refText}
            animate={controlsText}
            initial={{ x: -200, opacity: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center md:text-left w-full md:w-1/2"
          >
            <h1 className="text-2xl md:text-3xl font-bold mb-1 text-[#5D5044]">Hello, I'm</h1>
            <h2 className="text-3xl md:text-4xl font-semibold mb-2 text-[#7A6651]">
              Oktaryan <span className="text-[#A18C7A] font-bold">Hugo</span> Wiratama
            </h2>
            <p className="text-md md:text-lg text-[#6F6255] mb-4 leading-relaxed">
              A frontend developer. I enjoy creating{' '}
              <span className="block md:inline font-semibold text-[#8C6D5A] min-h-[1.5rem]">
                {text}
                <span className="animate-pulse">|</span>
              </span>
            </p>
            <motion.div
              onClick={() =>
                document
                  .getElementById('recent-works')
                  ?.scrollIntoView({ behavior: 'smooth' })
              }
              className="inline-block bg-[#8C6D5A] hover:bg-[#7B5E4C] text-white font-semibold px-6 py-2 rounded-lg cursor-pointer select-none"
              whileHover={{ scale: 1.09 }}
              transition={spring}
            >
              Dive In!
            </motion.div>
          </motion.div>

          <motion.img
            ref={refImg}
            animate={controlsImg}
            initial={{ x: 200, opacity: 0 }}
            transition={{ duration: 0.8 }}
            src={iam2}
            alt="I am Hugo"
            className="rounded-full w-64 h-64 md:w-80 md:h-80 border-4 bg-gradient-to-bl from-[#D9CFC2] to-[#7B5E4C] shadow-lg object-cover hover:scale-105 hover:shadow-md"
          />
        </div>
      </div>

      {/* Sosial Media dan Scroll */}
      <div className="flex justify-center items-center relative py-4">
        {/* Icon Sosial Media */}
        <div className="absolute right-10 flex text-xl text-[#7B5E4C]">
          <motion.a
            href="https://linkhub-hugo.vercel.app"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.14 }}
            transition={spring}
            className="cursor-pointer"
          >
            <FaLink />
          </motion.a>
        </div>

        {/* GIF Scroll */}
        <div className="flex-col items-center flex justify-center space-x-6 text-2xl">
          <img src={mouseGif} alt="Scroll down" className="w-8 h-8" />
        </div>
      </div>
    </section>
  );
};

export default Home;
